import { useValue } from '@morningtrain/react-resources'
import formatCompactNumber from 'support/formatters/formatCompactNumber'

export default function CompactNumber ({
  name,
  defaultValue = null,
  decimals = 0,
  minDecimals = 1,
  separatorMode = 'comma',
  numberSuffixes = []
}) {
  const value = useValue(name, defaultValue)

  return isNaN(value) ? 0 : formatCompactNumber(value, decimals, minDecimals, separatorMode, numberSuffixes)
}
